module.exports = "/_next/static/images/complexTechnologies-2x-44a540e905a585bbd3f5b9a120ab76e3.png";